import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider, useAuth } from "./auth";
import { DeviceProvider } from "./devices";
import BottomNav from "./BottomNav";
import Splash from "./screens/Splash";
import Login from "./screens/Login";
import Signup from "./screens/Signup";
import ForgotPassword from "./screens/ForgotPassword";
import LinkDevice from "./screens/LinkDevice";
import Home from "./screens/Home";
import Trips from "./screens/Trips";
import Geofences from "./screens/Geofences";
import Alerts from "./screens/Alerts";
import Settings from "./screens/Settings";

import HeadUnit from "./screens/HeadUnit";
import ShareView from "./screens/ShareView";
import Reports from "./screens/Reports";
import Onboarding from "./screens/Onboarding";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import AboutUs from "./screens/AboutUs";
import UserManual from "./screens/UserManual";
import Faq from "./screens/Faq";
import Footer from "./components/Footer";
import "./App.css";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || "27296314158-nhpj2ln9r0a5h5s4ah73r4a7hd5522kc.apps.googleusercontent.com";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div data-testid="checking-auth" className="min-h-screen flex items-center justify-center text-slate-400">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequiresOnboarded({ children }) {
  const { user, checking } = useAuth();
  if (checking)
    return (
      <div data-testid="checking-auth" className="min-h-screen flex items-center justify-center text-slate-400">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <AuthProvider>
      <DeviceProvider>
        <BrowserRouter>
        {/* Keyboard users otherwise tab through the whole shell before reaching
            the screen. Off-screen until it takes focus (see .skip-link). */}
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <main id="main-content">
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/link" element={<Protected><LinkDevice /></Protected>} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/home" element={<RequiresOnboarded><Home /></RequiresOnboarded>} />
          <Route path="/trips" element={<RequiresOnboarded><Trips /></RequiresOnboarded>} />
          <Route path="/geofences" element={<RequiresOnboarded><Geofences /></RequiresOnboarded>} />
          <Route path="/alerts" element={<RequiresOnboarded><Alerts /></RequiresOnboarded>} />
          <Route path="/reports" element={<RequiresOnboarded><Reports /></RequiresOnboarded>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/headunit" element={<HeadUnit />} />
          <Route path="/s/:token" element={<ShareView />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/user-manual" element={<UserManual />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </main>
        <Footer />
        <BottomNav />
        </BrowserRouter>
      </DeviceProvider>
    </AuthProvider>
    </GoogleOAuthProvider>
  );
}
